import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import styled from "styled-components";

const NewMissionSelector = ({ value, handleChange, description }) => (
  <>
    <Container>
      <FormControl component="fieldset">
        <FormLabel id={"formLabel"} component="legend">
          Choose a default starting schema:
        </FormLabel>
        <RadioGroup
          aria-label="startingSchema"
          name="startingSchema"
          value={value}
          onChange={handleChange}
        >
          <Wrapper>
            <FormControlLabel
              value="emptyMission"
              control={<Radio />}
              label="Empty Mission"
            />
            <FormControlLabel
              value="smallPvE"
              control={<Radio />}
              label="Small PvE"
            />
            <FormControlLabel
              value="mediumPvE"
              control={<Radio />}
              label="Medium PvE"
            />
            <FormControlLabel
              value="largePvE"
              control={<Radio />}
              label="Large PvE"
            />

            <FormControlLabel
              value="smallTvT"
              control={<Radio />}
              label="Small TvT"
            />
            <FormControlLabel
              value="mediumTvT"
              control={<Radio />}
              label="Medium TvT"
            />
            <FormControlLabel
              value="largeTvT"
              control={<Radio />}
              label="Large TvT"
            />
          </Wrapper>
        </RadioGroup>
      </FormControl>
    </Container>
    <p>{description}</p>
  </>
);

const Container = styled.div`
  > div {
    margin-top: 50px;
    margin-left: 25px;
    margin-right: 25px;
    white-space: pre-wrap;
  }
  #formLabel {
    padding-top: 15px;
    padding-left: 25px;
    color: white;
  }
  display: flex;
  flex-direction: row;
  border: 1px solid white;
  margin: 10px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 25px;
  min-width: 300px;

  > div {
    display: flex;
    justify-content: space-between;
    > label {
      min-width: 120px;
    }
  }
`;

export default NewMissionSelector;
